module.exports = __webpack_public_path__ + "static/kaka-5e91c8adb5eb6a05971cbd699b3cf1d8.jpg";